import {Form, Col, Button, Row} from '@deere/ux.uxframe-react'
import React from 'react'
import { useHistory } from "react-router";
import { EM_RESPONSE_STATUS,SCBM_STATES_CAMPAIGN, SCBM_USER_TYPE,EM_ADMIN, EM_IF_ADMIN } from '../../utils/surveyLiterals'
import { useTranslation } from "react-i18next";
import { useUserInfo } from '../../providers/userProvider'

function disableSubmitButtons(emResponse, campaign, userInfo, isSubmit){
    const deereUser = userInfo && userInfo.userType === SCBM_USER_TYPE.SALARY && !userInfo.roles.includes(EM_IF_ADMIN) && !userInfo.roles.includes(EM_ADMIN);
    return campaign.status === SCBM_STATES_CAMPAIGN.CLOSED || (emResponse.status === EM_RESPONSE_STATUS.SUBMITTED && isSubmit) || deereUser;
}

function disableDeleteButton(emResponse, campaign, userInfo, isSubmit){
    return campaign.status === SCBM_STATES_CAMPAIGN.CLOSED || (emResponse.status === EM_RESPONSE_STATUS.SUBMITTED && isSubmit) || ( !userInfo.roles.includes(EM_ADMIN) && !userInfo.roles.includes(EM_IF_ADMIN) );
}

export default function EMActionsPage({setShowAgreement,emResponse,setShowValidation,campaign, setShowDeereUserConfirmation}){
    const userInfo = useUserInfo();
    const history = useHistory();
    const { t } = useTranslation();    

    const submitSurveyResponses = () =>{
        if(userInfo.roles.includes(EM_IF_ADMIN) || userInfo.roles.includes(EM_ADMIN))
            setShowDeereUserConfirmation(true);
        else
            setShowAgreement(true);
    }

    const showValidation = () =>{
        setShowValidation(true)
    }

    return (<>
            <Row className="card position-sticky fixed-bottom d-print-none">
                <Row className="card position-sticky fixed-bottom">
                    <Col md="24" className="card-body p-3 text-right">
                        <Form.Group as={Col} className="align-right">  
                            <Button variant="primary" className="float-right" onClick={submitSurveyResponses} disabled={!emResponse || disableSubmitButtons(emResponse,campaign, userInfo, true)}>{t('btn_review_submit')}</Button>
                            <Button variant="secondary" className="float-right mr-2" onClick={e =>history.goBack()} >{t('btn_review_back_to_edit')}</Button> 
                            <Button variant="secondary" className="float-right mr-2" onClick={showValidation} disabled={!emResponse || disableDeleteButton(emResponse,campaign, userInfo, false)}>{t('btn_review_delete')}</Button>
                        </Form.Group>
                    </Col>
                </Row>
            </Row>             
             </>)
}   